import { notifyManager, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { captureAuthResponseBeforeTelemetry } from "./auth/previewRelay";
import { SESSION_ENDED_MESSAGE } from "./auth/sessionEnded";
import AuthGate from "./components/AuthGate";
import { DismissibleToaster } from "./components/ui";
import { initSentry } from "./lib/sentry";
import { installStaleChunkRecovery } from "./lib/staleChunkRecovery";
import { initializeTheme } from "./lib/theme";
import { createAppQueryClient } from "./queryClient";
import "./base.css";
import "./design-system/styles.css";
import "./components/ui/styles.css";

initializeTheme(window);
installStaleChunkRecovery(window);
notifyManager.setScheduler(queueMicrotask);

let callbackUrl: string | null = null;
let callbackError: string | null = null;
try {
  callbackUrl = captureAuthResponseBeforeTelemetry(window.location, (path) =>
    window.history.replaceState(null, "", path),
  );
} catch (error: unknown) {
  callbackError =
    error instanceof Error ? error.message : "OAuth response is invalid";
}

initSentry("fdr-e2e-agent-front");

const queryClient = createAppQueryClient();
const authScreenMessages = [SESSION_ENDED_MESSAGE];
const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root element is missing from index.html");

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthGate callbackUrl={callbackUrl} callbackError={callbackError}>
          <App />
        </AuthGate>
      </BrowserRouter>
      <DismissibleToaster excludedMessages={authScreenMessages} />
    </QueryClientProvider>
  </StrictMode>,
);
